import { readConsent } from "@/lib/consent";

/** Suivi publicitaire Meta Pixel / Google Ads : inactif tant que les identifiants ne sont pas renseignés, et seulement avec le consentement cookies. */
const META = process.env.REACT_APP_META_PIXEL_ID || "";
const GADS = process.env.REACT_APP_GOOGLE_ADS_ID || "";
let loaded = false;

function inject(src) {
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
}

export function loadAds() {
  if (loaded || !readConsent()?.analytics || (!META && !GADS)) return;
  loaded = true;
  if (META) {
    /* eslint-disable */
    const f = window; if (!f.fbq) { const n = (f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); }); n.push = n; n.loaded = true; n.version = "2.0"; n.queue = []; }
    /* eslint-enable */
    inject("https://connect.facebook.net/en_US/fbevents.js");
    window.fbq("init", META);
    window.fbq("track", "PageView");
  }
  if (GADS) {
    inject(`https://www.googletagmanager.com/gtag/js?id=${GADS}`);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); }; // eslint-disable-line prefer-rest-params
    window.gtag("js", new Date());
    window.gtag("config", GADS);
  }
}

/** event : PageView | AddToCart | InitiateCheckout | Purchase | Subscribe | Lead */
export function track(event, data = {}) {
  if (!loaded) return;
  if (META && window.fbq) window.fbq("track", event, { currency: "EUR", ...data });
  if (GADS && window.gtag) window.gtag("event", event === "Purchase" ? "purchase" : event.toLowerCase(), { currency: "EUR", ...data });
}
